import { render, staticRenderFns } from "./SuggestionListLink.vue?vue&type=template&id=ce2f7674&scoped=true&"
import script from "./SuggestionListLink.vue?vue&type=script&lang=js&"
export * from "./SuggestionListLink.vue?vue&type=script&lang=js&"
import style0 from "./SuggestionListLink.vue?vue&type=style&index=0&id=ce2f7674&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce2f7674",
  null
  
)

export default component.exports